import React, { useState, useEffect } from 'react';
import './NotificationSetup.css';

function NotificationSetup() {
  const [permission, setPermission] = useState('default');
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Check current notification permission
    if ('Notification' in window) {
      setPermission(Notification.permission);

      // Show prompt if not yet decided
      const dismissed = localStorage.getItem('notificationPromptDismissed');
      if (Notification.permission === 'default' && !dismissed) {
        setShowPrompt(true);
      }
    }
  }, []);

  const requestNotificationPermission = async () => {
    if (!('Notification' in window)) {
      alert('This browser does not support notifications');
      return;
    }

    try {
      const result = await Notification.requestPermission();
      setPermission(result);

      if (result === 'granted') {
        // Register service worker
        if ('serviceWorker' in navigator) {
          const registration = await navigator.serviceWorker.register('/service-worker.js');
          console.log('Service Worker registered:', registration);

          // Show success message
          new Notification('Workout Reminders Enabled! 💪', {
            body: 'You\'ll get reminders 30 minutes before your scheduled workouts',
            icon: '/icon-192.png'
          });
        }
        setShowPrompt(false);
      }
    } catch (error) {
      console.error('Error requesting notification permission:', error);
    }
  };

  const dismissPrompt = () => {
    setShowPrompt(false);
    localStorage.setItem('notificationPromptDismissed', 'true');
  };

  if (!showPrompt && permission === 'granted') {
    return (
      <div className="notification-status-badge">
        <span className="notification-icon">🔔</span>
        <span className="notification-text">Reminders Active</span>
      </div>
    );
  }

  if (!showPrompt) return null;

  return (
    <div className="notification-prompt-card">
      <div className="notification-prompt-header">
        <span className="notification-bell-icon">🔔</span>
        <h3 className="notification-prompt-title">Enable Workout Reminders?</h3>
      </div>

      <p className="notification-prompt-text">
        Get notified 30 minutes before your scheduled workouts, and a reminder if you haven't logged your workout yet.
      </p>

      <div className="notification-features">
        <div className="notification-feature">
          <span className="feature-icon">⏰</span>
          <span className="feature-text">Pre-workout reminders</span>
        </div>
        <div className="notification-feature">
          <span className="feature-icon">📝</span>
          <span className="feature-text">Missed workout alerts</span>
        </div>
        <div className="notification-feature">
          <span className="feature-icon">🎯</span>
          <span className="feature-text">Stay on track with your goals</span>
        </div>
      </div>

      <div className="notification-prompt-buttons">
        <button className="enable-notifications-btn" onClick={requestNotificationPermission}>
          Enable Notifications
        </button>
        <button className="dismiss-notifications-btn" onClick={dismissPrompt}>
          Maybe Later
        </button>
      </div>
    </div>
  );
}

export default NotificationSetup;
